import React, { useState, useRef } from "react";
import styled from "styled-components";

export default function TaskListItem({
  task,
  index,
  onChangeTaskStatus,
  onUpdateTaskTitle,
  onRemoveTask,
}) {
  const [isEdit, setIsEdit] = useState(false);
  const inputEl = useRef(null);

  return (
    <StyledTaskListItem>
      {!isEdit ? (
        <>
          <div className="title">{task.title}</div>
          <div className="control">
            <button className="button" onClick={() => setIsEdit(!isEdit)}>
              編集
            </button>
            <button className="button" onClick={() => onRemoveTask(index)}>
              削除
            </button>
            <button
              className="button -primary"
              onClick={() => onChangeTaskStatus(index)}
            >
              {task.isCompleted ? "戻す" : "完了する"}
            </button>
          </div>
        </>
      ) : (
        <div className="edit">
          <input type="text" defaultValue={task.title} autoFocus={true} ref={inputEl} />
          <button
            className="button -primary"
            onClick={() => {
              onUpdateTaskTitle(index, inputEl.current.value);
              setIsEdit(false);
            }}
          >
            変更する
          </button>
        </div>
      )}
    </StyledTaskListItem>
  );
}

const StyledTaskListItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #eee;
  @media screen and (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
    padding-top: 16px;
  }
  &:last-of-type {
    border-bottom: 1px solid #eee;
  }
  .title {
    display: flex;
    align-items: center;
    flex: 1;
    font-size: 18px;
  }
  .control {
    display: flex;
    align-items: center;
    padding: 16px 0;
    @media screen and (max-width: 767px) {
      align-self: flex-end;
    }
    button {
      & + button {
        margin-left: 8px;
      }
    }
  }
  .edit {
    display: flex;
    align-items: center;
    padding: 16px 0;
    flex: 1;
    button {
      margin-left: 8px;
    }
  }
`;